// Format the phone number as (XXX) XXX-XXXX
const formatPhoneNumber = (phoneNumber) => {
  const digitsOnly = phoneNumber.replace(/\D/g, '');

  const formattedNumber = digitsOnly.replace(
    /(\d{0,3})(\d{0,3})(\d{0,4})/,
    (match, part1, part2, part3) => {
      let formatted = '';
      if (part1) {
        formatted += `(${part1}`;
      }
      if (part2) {
        formatted += `) - ${part2}`;
      }
      if (part3) {
        formatted += ` - ${part3}`;
      }
      return formatted;
    }
  );

  return formattedNumber;
};

// Convert a phone number to digits only
const convertPhoneNumberToDigits = (phoneNumber) => phoneNumber.replace(/\D/g, '');

export { formatPhoneNumber, convertPhoneNumberToDigits };
